import Back from "../../../assets/client/arrow-back.svg?react";
import "./styles.scss";

export const TripsModalCloseIcon = () => {
  return <Back className="back-arrow trips-modal-close-icon" />;
};
